export class PaymentMethod {
  id!: string;
  object!: string;
  allow_redisplay!: 'always' | 'limited' | 'unspecified';
  billing_details!: BillingDetailsDto;
  card!: CardDto;
  created!: number;
  customer!: string | null;
  customer_account!: string | null;
  livemode!: boolean;
  metadata!: Record<string, any>;
  type!: 'card';
  isDefault: boolean = false;

  constructor(data?: Partial<PaymentMethod>) {
    Object.assign(this, data);
    if(data?.billing_details) this.billing_details = new BillingDetailsDto(data.billing_details);
    if(data?.card) this.card = new CardDto(data.card);
  }
}

export class BillingDetailsDto {
  address!: AddressDto;
  email!: string | null;
  name!: string | null;
  phone!: string | null;
  tax_id!: string | null;

  constructor(data?: Partial<BillingDetailsDto>) {
    Object.assign(this, data);
    if(data?.address) this.address = new AddressDto(data.address);
  }
}

export class AddressDto {
  city!: string | null;
  country!: string | null;
  line1!: string | null;
  line2!: string | null;
  postal_code!: string | null;
  state!: string | null;

  constructor(data?: Partial<AddressDto>) {
    Object.assign(this, data);
  }
}

export class CardDto {
  brand!: string;
  display_brand!: string;
  country!: string;
  exp_month!: number;
  exp_year!: number;
  funding!: 'credit' | 'debit' | 'prepaid' | string;
  last4!: string;
  fingerprint!: string;
  generated_from!: any | null;
  regulated_status!: string;
  wallet!: any | null;
  checks!: CardChecksDto;
  networks!: CardNetworksDto;
  three_d_secure_usage!: ThreeDSecureUsageDto;

  constructor(data?: Partial<CardDto>) {
    Object.assign(this, data);
    if(data?.checks) this.checks = new CardChecksDto(data.checks);
    if(data?.networks) this.networks = new CardNetworksDto(data.networks);
    if(data?.three_d_secure_usage) this.three_d_secure_usage = new ThreeDSecureUsageDto(data.three_d_secure_usage);
  }
}

export class CardNetworksDto {
  available!: string[];
  preferred!: string | null;

  constructor(data?: Partial<CardNetworksDto>) {
    Object.assign(this, data);
  }
}


export class ThreeDSecureUsageDto {
  supported!: boolean;

  constructor(data?: Partial<ThreeDSecureUsageDto>) {
    Object.assign(this, data);
  }
}

export class CardChecksDto {
  address_line1_check!: string | null;
  address_postal_code_check!: string | null;
  cvc_check!: 'pass' | 'fail' | 'unchecked' | null;

  constructor(data?: Partial<CardChecksDto>) {
    Object.assign(this, data);
  }
}
